// extracted by mini-css-extract-plugin
module.exports = {"post":"zine-post_post__gBcK2","header":"zine-post_header__gzF6Z","body":"zine-post_body__u1TDo","related":"zine-post_related__5VAKp"};